import type { IClickToText } from 'entities/ClickToText'
import { ClickToTextDetailsModalContext } from 'pages/clickToText/pages/all/context'
import { DetailsClickToTextModalContent } from './DetailsClickToTextModalContent'

type IDetailsClickToTextModalProps = {
  clickToText: IClickToText
}

export const DetailsClickToTextModal = ({ clickToText }: IDetailsClickToTextModalProps) => {
  return (
    <ClickToTextDetailsModalContext.Provider value={clickToText}>
      <DetailsClickToTextModalContent />
    </ClickToTextDetailsModalContext.Provider>
  )
}
